import React, { useState, useEffect } from 'react'

import { connectRange } from 'react-instantsearch-dom'

import moment from 'moment'

import { Select } from 'antd'

const last7Days = {
  min: moment().subtract(7, 'days').startOf('day').toDate().getTime(),
  max: moment().endOf('day').toDate().getTime(),
}

const last14Days = {
  min: moment().subtract(14, 'days').startOf('day').toDate().getTime(),
  max: moment().endOf('day').toDate().getTime(),
}

const lastMonth = {
  min: moment().subtract(1, 'months').startOf('day').toDate().getTime(),
  max: moment().endOf('day').toDate().getTime(),
}

export const defaultProps = {
  defaultRefinement: last14Days,
  // Set a big range here because connectRange blocks select dates outside the range
  min: moment('01/01/2020', 'DD/MM/YYYY').startOf('day').toDate().getTime(),
  max: moment().endOf('day').toDate().getTime(),
}

const RefinementList = (props) => {
  const { refine, min, max, style, currentRefinement } = props

  const [value, setValue] = useState('')

  const options = [
    {
      label: 'Last 7 Days',
      value: '7',
      min: last7Days.min,
      max: last7Days.max,
    },
    {
      label: 'Last 14 Days',
      value: '14',
      min: last14Days.min,
      max: last14Days.max,
    },
    {
      label: 'Last Month',
      value: '30',
      min: lastMonth.min,
      max: lastMonth.max,
    },
    {
      label: 'All Orders',
      value: 'all',
      min,
      max,
    },
  ]

  useEffect(() => {
    const selectedOption = options.find((option) => option.min === currentRefinement.min)

    if (selectedOption) {
      setValue(selectedOption.value)
    }
  }, [currentRefinement, options])

  return (
    <Select
      data-cy="filter-by-days"
      onChange={(_, item) => refine({ min: item['min'], max: item['max'] })}
      value={value}
      bordered={false}
      style={{ fontSize: 22, minWidth: 200, width: '100%', ...style }}
      showArrow
      options={options}
    />
  )
}

export const FilterLastDays = connectRange(RefinementList)
